var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#083358",
  rx: 4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#search-button_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.125 9a6.87 6.87 0 0 0-6.875 6.875c0 1.626.561 3.166 1.592 4.4l-3.659 3.658a.625.625 0 1 0 .884.884l3.659-3.659a6.82 6.82 0 0 0 4.399 1.592c3.8 0 6.875-3.075 6.875-6.875S21.925 9 18.125 9m0 12.5a5.63 5.63 0 0 1-5.625-5.625 5.63 5.63 0 0 1 5.625-5.625 5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search-button_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 9h16v16H9z"
})))));
export default SvgSearchButton;